import axios from "axios";

const PRESENCAS_URL =
  `${process.env.REACT_APP_API_URL}/evolucao_ativos` ||
  "http://localhost:3001/evolucao_ativos";

export async function getEvolucaoAtivos(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(PRESENCAS_URL, { headers });
  return response.data;
}
